import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/">MCQ BD</Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainMenu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>

            {/* -------------------- DROPDOWN -------------------- */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="examDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                MCQ Exams
              </a>

              <ul className="dropdown-menu" aria-labelledby="examDropdown">
                <li>
                  <Link className="dropdown-item" to="/exam/bcs">
                    BCS Exam
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/exam">
                    Bar Council
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/exam/ntcsa">
                    NTCSA Exam
                  </Link>
                </li>

                <li>
                  <hr className="dropdown-divider" />
                </li>

                <li>
                  <Link className="dropdown-item" to="/exam/all">
                    All MCQ Collections
                  </Link>
                </li>
              </ul>
            </li>
            {/* --------------------------------------------------- */}

            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}
